import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { truncateFilename } from "../../hooks/utils";
import { checkAuthenticated } from "../../actions/auth";
import { useDispatch } from "react-redux";
import { import_patients } from "../../actions/clinic_content";

const initialExcelFile = {
  file: null,
  name: "",
};
const ImportPatientsModal = (props) => {
  const dispatch = useDispatch();
  const { show, onHide } = props;
  const [excelFile, setExcelFile] = useState(initialExcelFile);
  const handleFileChange = (event) => {
    setExcelFile({
      file: event.target.files[0],
      name: truncateFilename(event.target.files[0].name, 30),
    });
  };
  const handleOnHide = () => {
    setExcelFile(initialExcelFile);
    onHide();
  };
  const handleSubmit = async () => {
    dispatch(checkAuthenticated());
    const filename = excelFile.file.name;
    const extension = filename.split(".").pop();

    if (extension == "xlsx" || extension == "csv") {
      await import_patients(excelFile.file);
      handleOnHide();
    } else {
      console.log("Archivo no soportado. Porfavor ingresar archivo XLSX o CSV");
    }
  };
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header className="justify-content-center">
        <Modal.Title>Ingresar Excel</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="transaction-modal-body d-flex flex-column gap-2">
          <div className="input-field">
            <label htmlFor="exampleFormControlTextarea1" className="form-label">
              Archivo de Transaccion
            </label>
            <div className="file-input-group input-group">
              <div className="files-container flex-fill px-2">
                <span className="badge text-bg-secondary">
                  {excelFile.name}
                </span>
              </div>
              <input
                className="form-control d-none"
                type="file"
                id="inpuExclFile"
                onChange={handleFileChange}
              />
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={() => document.getElementById("inpuExclFile").click()}
              >
                Subir Archivo
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        <div className="d-flex flex-fill justify-content-end gap-2">
          <Button variant="secondary" onClick={handleOnHide}>
            Cerrar
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={excelFile.file ? false : true}
          >
            Agregar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ImportPatientsModal;
